(function () {
  'use strict';

  var STORAGE_KEY = 'moderny_active_credit';
  var COOKIE_NAME = 'moderny_credit_active';
  var SYMBOLS     = { USD: '$', EUR: '€', GBP: '£' };

  function getOrdinal(n) {
    var s = ['th', 'st', 'nd', 'rd'];
    var v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
  }

  // Date-only strings parse as UTC midnight; append T23:59:59 to treat as end-of-day local time
  function normaliseDateStr(str) {
    return str.indexOf('T') !== -1 ? str : str + 'T23:59:59';
  }

  function formatExpiry(expiresStr) {
    if (!expiresStr) return null;
    try {
      var date = new Date(normaliseDateStr(expiresStr));
      if (isNaN(date.getTime())) return null;
      var weekday = new Intl.DateTimeFormat('en-US', { weekday: 'long' }).format(date);
      var month   = new Intl.DateTimeFormat('en-US', { month: 'long' }).format(date);
      var day     = getOrdinal(date.getDate());
      var time    = new Intl.DateTimeFormat('en-US', { hour: 'numeric', minute: '2-digit', hour12: true }).format(date);
      return weekday + ', ' + month + ' ' + day + ' at ' + time;
    } catch (e) {
      return null;
    }
  }

  function isExpired(expiresStr) {
    try {
      var d = new Date(normaliseDateStr(expiresStr));
      return isNaN(d.getTime()) || new Date() >= d;
    } catch (e) {
      return true;
    }
  }

  function isVisible(el) {
    if (!el || el.offsetParent === null) return false;
    var s = window.getComputedStyle(el);
    return s.display !== 'none' && s.visibility !== 'hidden' && parseFloat(s.opacity) > 0;
  }

  function clearCookie() {
    document.cookie = COOKIE_NAME + '=; path=/; max-age=0';
  }

  function clearCredit() {
    try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
    clearCookie();
  }

  function setCreditCookie(expiresStr) {
    try {
      var ttl = Math.max(0, (new Date(normaliseDateStr(expiresStr)) - new Date()) / 1000);
      document.cookie = COOKIE_NAME + '=1; path=/; max-age=' + Math.floor(ttl);
    } catch (e) {}
  }

  function readStorage() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function writeStorage(obj) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(obj)); } catch (e) {}
  }

  // ─── Init ──────────────────────────────────────────────────────────────────

  function init() {
    var params      = new URLSearchParams(window.location.search);
    var urlDiscount = params.get('discount');
    var urlCredit   = params.get('credit');
    var urlExpires  = params.get('expires');
    var urlMin      = params.get('min');
    var urlCurrency = params.get('currency');

    var activeCredit;

    if (urlDiscount && urlCredit && urlExpires) {
      // Fresh email click — always override dismissed flag and reset idempotency
      activeCredit = {
        discount: urlDiscount,
        credit: urlCredit,
        expires: urlExpires,
        min: urlMin || null,
        currency: urlCurrency || null,
        dismissed: false
      };
      writeStorage(activeCredit);
      setCreditCookie(urlExpires);
    } else {
      activeCredit = readStorage();
    }

    if (!activeCredit) return;

    // Purge if expired
    if (isExpired(activeCredit.expires)) {
      clearCredit();
      return;
    }

    // Apply discount at cart/session level — idempotent, fires once per activation
    if (activeCredit.discount && !activeCredit.discount_applied) {
      fetch('/discount/' + encodeURIComponent(activeCredit.discount), {
        method: 'GET',
        credentials: 'same-origin'
      }).then(function () {
        activeCredit.discount_applied = true;
        writeStorage(activeCredit);
      }).catch(function () { /* silent fail; checkout-level still works as fallback */ });
    }

    // Respect dismissed flag (URL params already reset it above)
    if (activeCredit.dismissed) return;

    renderBanner(activeCredit);
  }

  // ─── Render ────────────────────────────────────────────────────────────────

  function renderBanner(activeCredit) {
    // Overlay conflict check — retry after 500ms if a competing modal is visible
    var conflicting = document.querySelector([
      '.klaviyo-form-overlay',
      '[role="dialog"][aria-modal="true"]',
      '#rebuy-modal:not([style*="display: none"])',
      '.rebuy-cart-drawer.is-open',
      '[data-rebuy-modal][aria-hidden="false"]'
    ].join(','));

    if (conflicting && isVisible(conflicting)) {
      setTimeout(function () { renderBanner(activeCredit); }, 500);
      return;
    }

    var banner = document.getElementById('credit-banner');
    if (!banner) return;

    // ── Currency symbol ───────────────────────────────────────────────────────
    var symbol = SYMBOLS[activeCredit.currency] || '$';

    // ── Populate compact text ─────────────────────────────────────────────────
    banner.querySelector('.credit-banner__amount').textContent = symbol + activeCredit.credit + ' credit';

    var formatted     = formatExpiry(activeCredit.expires);
    var expiresEl     = banner.querySelector('.credit-banner__expires');
    var expiresSep    = banner.querySelector('.credit-banner__sep');
    var expiresRow    = banner.querySelector('.credit-banner__expires-item');
    var expiresDetail = banner.querySelector('.credit-banner__expires-detail');

    if (formatted) {
      expiresEl.textContent = 'expires ' + formatted;
      expiresDetail.textContent = formatted;
    } else {
      if (expiresEl)  expiresEl.style.display  = 'none';
      if (expiresSep) expiresSep.style.display = 'none';
      if (expiresRow) expiresRow.style.display = 'none';
    }

    // ── Populate drawer ───────────────────────────────────────────────────────
    banner.querySelector('.credit-banner__drawer-title').textContent = 'Your ' + symbol + activeCredit.credit + ' credit';
    banner.querySelector('.credit-banner__code').textContent = activeCredit.discount;

    // Min spend bullet — hide if min is 0, null, or absent
    var minItem       = banner.querySelector('.credit-banner__min-item');
    var minEl         = banner.querySelector('.credit-banner__min');
    var minCurrencyEl = banner.querySelector('.credit-banner__min-currency');
    var minVal        = parseFloat(activeCredit.min);
    if (minItem && minEl && activeCredit.min !== null && !isNaN(minVal) && minVal > 0) {
      if (minCurrencyEl) minCurrencyEl.textContent = symbol;
      minEl.textContent = activeCredit.min;
      minItem.style.display = '';
    }

    // ── Show with entrance animation ──────────────────────────────────────────
    banner.style.display = '';
    // Double rAF: ensures browser renders initial transform state before transition fires
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        banner.classList.add('is-visible');
      });
    });

    // ── Drawer open/close ─────────────────────────────────────────────────────
    var infoBtn     = banner.querySelector('.credit-banner__info-btn');
    var dismissBtn  = banner.querySelector('.credit-banner__dismiss-btn');
    var continueBtn = banner.querySelector('.credit-banner__continue-btn');
    var drawerClose = banner.querySelector('.credit-banner__drawer-close');
    var drawer      = banner.querySelector('.credit-banner__drawer');

    function openDrawer() {
      banner.classList.add('is-expanded');
      drawer.setAttribute('aria-hidden', 'false');
      infoBtn.setAttribute('aria-expanded', 'true');
    }

    function closeDrawer() {
      banner.classList.remove('is-expanded');
      drawer.setAttribute('aria-hidden', 'true');
      infoBtn.setAttribute('aria-expanded', 'false');
    }

    infoBtn.addEventListener('click', openDrawer);
    continueBtn.addEventListener('click', closeDrawer);
    drawerClose.addEventListener('click', closeDrawer);

    // ── Dismiss ───────────────────────────────────────────────────────────────
    dismissBtn.addEventListener('click', function () {
      var stored = readStorage() || {};
      stored.dismissed = true;
      writeStorage(stored);
      clearCookie();
      banner.classList.remove('is-visible');
      setTimeout(function () { banner.style.display = 'none'; }, 350);
    });

    // ── Rebuy cart coordination ───────────────────────────────────────────────
    document.addEventListener('rebuy:cart.show',  function () { banner.classList.add('is-hidden'); });
    document.addEventListener('rebuy:cart.hide',  function () { banner.classList.remove('is-hidden'); });
    document.addEventListener('rebuy:modal.show', function () { banner.classList.add('is-hidden'); });
    document.addEventListener('rebuy:modal.hide', function () { banner.classList.remove('is-hidden'); });

    // Defensive MutationObserver in case Rebuy events don't fire on this theme
    var observer = new MutationObserver(function () {
      var rebuyOpen = document.querySelector(
        '#rebuy-modal:not([style*="display: none"]), .rebuy-cart-drawer.is-open, [data-rebuy-modal][aria-hidden="false"]'
      );
      banner.classList.toggle('is-hidden', !!rebuyOpen);
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'aria-hidden']
    });

    // ── Internal link discount preservation ───────────────────────────────────
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a');
      if (!a) return;
      try {
        if (a.href.indexOf(location.host) === -1) return;
        var url = new URL(a.href);
        if (!url.searchParams.has('discount') && activeCredit.discount) {
          url.searchParams.set('discount', activeCredit.discount);
          a.href = url.toString();
        }
      } catch (ex) {}
    });
  }

  // ─── Boot ──────────────────────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
